/* MUI */
import { Box, Button } from '@mui/material';

/*  Shared  */
import { Constants, ScopeTypes, URLs } from 'application/Shared/Constants';
import { Browser } from 'application/Shared/Handlers';
import { Helpers, SessionHelper } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  Images  */
import Image from 'images/Microsoft_logo.svg';

/*  Objects  */
import Session from 'objects/Session';

/*  React  */
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import {
    AUTH_POPUP_WINDOW_FEATURES,
    AUTH_POPUP_WINDOW_TARGET
} from '../Constants';

class MicrosoftAuth extends PureComponent {
    componentWillUnmount() {
        this.unload();
    }

    unload = () => {
        window.removeEventListener('storage', this.handleStorage);
    };

    handleSession = async () => {
        const { setSessionInfo } = this.props;

        const userSession = await Session.getSessionInfo();
        const sessionHelper = new SessionHelper(userSession);
        const tenant = sessionHelper.getTenant();
        setSessionInfo(userSession);
        Browser.handleTabTitle({ tenant });
    };

    handleStorage = (message) => {
        const { key, newValue } = message;

        if (key !== 'jwt') {
            return true;
        }

        if (newValue === 'NEW_TENANT') {
            window.removeEventListener('storage', this.handleStorage);
            window.location.href = URLs.waitlist;
            return true;
        }

        if (newValue && newValue !== 'null') {
            window.removeEventListener('storage', this.handleStorage);
            this.handleSession();
            return true;
        }

        debug.e('Unhandled Value', newValue);
        return true;
    };

    additionalParamsForScopeType = () => {
        const { scopeType, azureTenantId } = this.props;
        switch (scopeType) {
            case ScopeTypes.Impersonation:
                return {
                    scope: 'https://management.azure.com/user_impersonation',
                    state: 'requestType=browser_12345_microsoft&scope=impersonation'
                };
            case ScopeTypes.AppAuth:
                return {
                    scope: '.default',
                    // scope: 'AuditLog.Read.All Directory.Read.All Group.Read.All Organization.Read.All Team.ReadBasic.All User.Read.All',
                    // prompt: 'consent',
                    state: `requestType=browser_12345_microsoft&scope=appAuth&azureTenantId=${azureTenantId}`
                };
            default:
                return {
                    scope: 'user.read',
                    state: 'requestType=browser_12345_microsoft'
                };
        }
    };

    buildUrl = (payload) => {
        const { scopeType, azureTenantId } = this.props;
        switch (scopeType) {
            case ScopeTypes.Impersonation:
                // The user_impersonation request doesn't seem to work with the v2.0 auth endpoint :shrug:
                return `https://login.microsoftonline.com/common/oauth2/authorize?${payload}`;
            case ScopeTypes.AppAuth:
                return `https://login.microsoftonline.com/${azureTenantId}/oauth2/authorize?${payload}`;
            default:
                return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${payload}`;
        }
    };

    login = () => {
        const { scopeType } = this.props;

        const additionalPayloadParams = this.additionalParamsForScopeType();

        const payload = Helpers.urlParams({
            client_id: Constants.microsoftClientIdAsm,
            prompt: 'select_account',
            redirect_uri: `${window.origin}/close`,
            response_mode: 'query',
            response_type: 'code',
            ...additionalPayloadParams
        });

        const authUrl = this.buildUrl(payload);
        window.open(
            authUrl,
            AUTH_POPUP_WINDOW_TARGET,
            AUTH_POPUP_WINDOW_FEATURES
        );

        if (scopeType === ScopeTypes.Login) {
            window.addEventListener('storage', (message) =>
                this.handleStorage(message)
            );
        }
    };

    render() {
        const { buttonTextKey, disabled, login, t } = this.props;
        const buttonText = buttonTextKey
            ? t(buttonTextKey)
            : t('Common.login_microsoft');

        return (
            <Button
                onClick={this.login}
                color="primary"
                variant="outlined"
                style={{ width: '100%' }}
                disabled={disabled}
                data-testid="microsoftAuth"
                data-trackid="login_microsoftAuth"
            >
                <Box
                    display="flex"
                    width="100%"
                    alignItems="center"
                    justifyContent="center"
                >
                    {login ? (
                        <>
                            <Box width="30%" textAlign="right">
                                <img
                                    aria-hidden="true"
                                    src={Image}
                                    alt={t('Common.login_microsoft')}
                                    style={{
                                        height: '20px',
                                        marginRight: '16px'
                                    }}
                                />
                            </Box>
                            <Box
                                width="70%"
                                textAlign="left"
                                textTransform="uppercase"
                            >
                                {buttonText}
                            </Box>
                        </>
                    ) : (
                        <>
                            <img
                                aria-hidden="true"
                                src={Image}
                                alt={t('Common.login_google')}
                                style={{ height: '20px', marginRight: '16px' }}
                            />
                            <Box textTransform="uppercase">{buttonText}</Box>
                        </>
                    )}
                </Box>
            </Button>
        );
    }
}

MicrosoftAuth.defaultProps = {
    azureTenantId: null,
    scopeType: ScopeTypes.Login
};

export default withTranslation()(MicrosoftAuth);
